import {
  EMAIL_SERVICE_PROD,
  EMAIL_FUTURE_SCHOLAR_PROD,
} from '../../../global/environments/config'
import { emailContactRecipients } from './formConfig.js'

const isServiceRequest = (recipientEmail) => {
  return (
    recipientEmail.includes(EMAIL_SERVICE_PROD) ||
    recipientEmail.includes(EMAIL_FUTURE_SCHOLAR_PROD)
  )
}

const buildServiceRequest = () => {
  return {
    isService: true,
    from: 'serviceinquiries@columbiathreadneedle.com',
  }
}

const buildNonServiceRequest = (email) => {
  return {
    isService: false,
    from: email,
  }
}

const checkEmailRerouting = (recipientEmail, email) => {
  const payload = isServiceRequest(recipientEmail)
    ? buildServiceRequest()
    : buildNonServiceRequest(email)

  return {
    ...payload,
    to: [recipientEmail],
  }
}

export const createEmailPayload = (service, formData) => {
  // If the recipient email is a service email, we need to send the email from a generic service email address
  const emailAddress = checkEmailRerouting(
    service.recipientEmail,
    formData.email
  )
  return {
    type: 'email',
    data: {
      from: emailAddress.from,
      to: emailAddress.to,
      subject: service.subject,
      body: JSON.stringify(
        Object.entries(formData)
          .map((e) => {
            if (e[1] === null || e[1].trim() === '') {
              return e[0] + ': N/A'
            }
            return e.join(': ')
          })
          .join('<br/>')
      ),
    },
  }
}

export const getServiceType = (search) => {
  const searchArray = search && search.split('=')
  const serviceType = searchArray.length > 1 && searchArray[1]
  return serviceType in emailContactRecipients
    ? emailContactRecipients[serviceType]
    : emailContactRecipients.default
}
